import React from 'react';

import palette from '../../color-palette';

const SetMenu = (props) => {
  const {
    primary: { main },
  } = palette;

  return (
    <svg viewBox="0 0 60 60" {...props}>
      <g id="SetMenu_svg__Layer_1">
        <path
          fill="none"
          stroke={main}
          strokeWidth={0.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M45.48 51.69H14.52c-.67 0-1.22-.55-1.22-1.22V9.52c0-.67.55-1.22 1.22-1.22h30.95c.67 0 1.22.55 1.22 1.22v40.95c0 .68-.54 1.22-1.21 1.22z"
        />
        <path
          fill="none"
          stroke={main}
          strokeWidth={0.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M21.54 11.8h20.87v32.42l-3.84 3.83H17.5V15.69z"
        />
        <path
          fill={main}
          d="M23.77 19.43l-.88-1.56c-.11-.19-.2-.35-.22-.43l-.02.01c.01.06-.04.26-.1.46l-.24.82c-.05.17-.11.38-.16.6h-1.18c.08-.26.18-.58.21-.71l1.06-3.73h.09l1.23 2.07c.18.3.24.44.24.5h.02c.01-.07.08-.22.24-.5l1.19-2.07h.09l1.11 3.72c.08.27.22.72.22.72h-1.19l-.18-.61-.24-.78c-.07-.22-.12-.38-.11-.44l-.02-.01c-.02.08-.1.24-.22.45l-.86 1.49h-.08zM27.23 15.08h1.58c.21 0 .61-.01.73-.01v1.01c-.12 0-.52-.01-.73-.01h-.5v.63h.27c.21 0 .61-.01.73-.01v1.01c-.12 0-.52-.01-.73-.01h-.28v.63h.6c.21 0 .61-.01.73-.01v1.01c-.12 0-.52-.01-.73-.01h-1.67v-4.23zM30.49 14.97l2.37 1.89c.19.16.22.19.34.36l.02-.01c-.01-.06-.04-.22-.04-.45v-.95c0-.21-.01-.61-.01-.73h1.18c0 .12-.01.52-.01.73v3.64h-.11l-2.37-1.95a1.42 1.42 0 01-.34-.36l-.02.01c.01.06.04.22.04.45v1.02c0 .21.01.61.01.73h-1.18c0-.12.01-.52.01-.73v-3.64h.11zM36.43 15.81v2.01c0 .21.09.4.23.5.14.1.33.15.57.15.28 0 .52-.1.64-.18v-2.48c0-.21-.01-.61-.01-.73h1.18c0 .12-.01.52-.01.73v3.14c-.24.18-.73.51-1.81.51-.66 0-1.08-.1-1.4-.32-.37-.26-.57-.66-.57-1.32v-2.01c0-.21-.01-.61-.01-.73h1.18c.01.11.01.52.01.73z"
        />
        <path
          fill="none"
          stroke={main}
          strokeWidth={0.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M22.08 22.29h15.6M22.08 24.98h15.6M22.08 28.49h15.6M22.08 32.15h15.6M22.08 34.84h15.6M22.12 38.45h15.6M22.2 41.84h15.6M22.16 44.52h15.59"
        />
      </g>
    </svg>
  );
};

export default SetMenu;
